
























    import { Component, Vue, Prop, Watch } from "vue-property-decorator";
    import {nextTick} from "process";
import { setTimeout } from "timers";

    @Component({

    })
    export default class InlineTextEdit extends Vue {
        @Prop({}) icon : string;
        @Prop({}) bordered : boolean;
        @Prop({}) shouldautofocus : boolean;
        @Prop({}) noautocomplete : boolean;
        @Prop({}) placeholder : string;
        @Prop({}) borderHide : boolean;
        @Prop({}) placeholderNoMove : boolean;
        @Prop({}) error : boolean;
        @Prop({}) defaultValue:any;
        @Prop({}) password : {
            default: false,
            type: boolean
        };
        @Prop({}) paddingBottom : {
            default: false,
            type: boolean
        };
        @Prop({}) readonly : {
            default: false,
            type: boolean
        };

        giveError:boolean = false;
        value:any = '';
        focusing: boolean = false;
        input:HTMLInputElement = null;

        stopAutofillCheck:boolean = false;

        mounted(){
            this.input = this.$refs.textInput as HTMLInputElement;
            this.updateDefaultValue();
            this.detectAutofill();
        }

        detectAutofill(){
        }
        
        setValue(to:string){
            (this.$refs.textInput as HTMLInputElement).innerHTML = to;
        }

        focus(){
            this.stopAutofillCheck = true;
            if(!this.readonly){
                this.input.focus();
                this.focusing = true;
            }
        }

        unfocus(){
            this.focusing = false;
            if(!this.value || (this.value).trim() == ''){
                this.value = '';
            }
        }

        @Watch('value')
        updatevalue(to, from){
            this.$emit('input', to)
            this.giveError = false;
        }
        
        @Watch('error')
        updateError(to, from){
            this.giveError = this.error;
        }

        @Watch('defaultValue')
        updateDefaultValue(){
            if(!this.focusing){
                this.value = this.defaultValue;
                this.$nextTick(() => {
                    this.setValue(this.value);
                })
            }
        }

    }

